import React, { useState } from 'react';
import { ShieldCheckIcon, MessageSquareIcon, GaugeIcon, UserCheckIcon, HelpCircleIcon, StarIcon, CheckCircle2Icon, ArrowRightIcon, SparklesIcon, BarChart3Icon, FilterIcon, MapPinIcon, TrendingUpIcon } from 'lucide-react';
export function AtnaAnalytics() {
  const [selectedService, setSelectedService] = useState('Urbanisme');
  const services = [{
    name: 'Urbanisme',
    status: 'yellow',
    questions: '3,210',
    confidence: '91%',
    autonomy: '74%',
    pending: 4
  }, {
    name: 'Travaux publics',
    status: 'green',
    questions: '4,180',
    confidence: '97%',
    autonomy: '88%',
    pending: 3
  }, {
    name: 'Environnement',
    status: 'yellow',
    questions: '2,540',
    confidence: '89%',
    autonomy: '68%',
    pending: 2
  }, {
    name: 'Loisirs',
    status: 'green',
    questions: '1,920',
    confidence: '96%',
    autonomy: '85%',
    pending: 1
  }, {
    name: 'Permis',
    status: 'red',
    questions: '990',
    confidence: '82%',
    autonomy: '51%',
    pending: 6
  }];
  const activeServiceData = services.find(s => s.name === selectedService) || services[0];
  const kpis = [{
    icon: ShieldCheckIcon,
    label: 'Réponses vérifiées',
    value: '98.7%',
    note: '+1.2 pt vs mois préc.',
    noteColor: 'text-emerald-600'
  }, {
    icon: MessageSquareIcon,
    label: 'Réponses générées',
    value: '12,840',
    note: 'ce mois-ci',
    noteColor: 'text-slate-500'
  }, {
    icon: GaugeIcon,
    label: 'Confiance moyenne',
    value: '96.4%',
    note: 'seuil municipal : 95%',
    noteColor: 'text-slate-500'
  }, {
    icon: UserCheckIcon,
    label: 'Validations humaines',
    value: '320',
    note: '5 en attente',
    noteColor: 'text-amber-600'
  }, {
    icon: HelpCircleIcon,
    label: 'Questions sans réponse',
    value: '7',
    note: 'à documenter',
    noteColor: 'text-amber-600'
  }, {
    icon: StarIcon,
    label: 'Satisfaction citoyenne',
    value: '4.8 / 5',
    note: 'sur 2,140 évaluations',
    noteColor: 'text-slate-500'
  }];
  return <div className="space-y-8 animate-in fade-in duration-300" data-id="element-253" data-mp="24csdpqqwedky">
      {/* SECTION 1 — Executive Summary */}
      <section data-id="element-254" data-mp="1zez4eouat3gg">
        <div className="flex items-center justify-between mb-4" data-id="element-255" data-mp="1zcd1j2icrc4k">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading flex items-center gap-2" data-id="element-256" data-mp="1udjkj03ux2zn">
            <BarChart3Icon className="w-5 h-5 text-[#4F46E5]" data-id="element-257" data-mp="1pfi3ekpzrdqt" />
            Sommaire Exécutif — Intelligence Municipale
          </h2>
          <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-258" data-mp="1lg9cdnmc5tyy">
            <FilterIcon className="w-4 h-4" data-id="element-259" data-mp="1gmesaj2tjczc" />
            <span data-id="element-260" data-mp="1bo3jmbo9f8ip">30 derniers jours</span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-261" data-mp="1bmabery00g8l">
          {kpis.map((kpi, i) => {
          const Icon = kpi.icon;
          return <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-slate-100" data-id="element-262" data-mp="11pe0kfkmni0v" data-mpi={i}>
                <div className="flex items-center gap-3 mb-2" data-id="element-263" data-mp="xpwtxitgseu4">
                  <div className="p-2 bg-indigo-50 text-[#4F46E5] rounded-lg" data-id="element-264" data-mp="39ch4s6pzq1lm">
                    <Icon className="w-5 h-5" data-id="element-265" data-mp="39ejs2izrdgmn" />
                  </div>
                  <h3 className="text-sm font-medium text-slate-600" data-id="element-266" data-mp="3dc7sg1k801lx">
                    {kpi.label}
                  </h3>
                </div>
                <div className="flex items-end gap-3" data-id="element-267" data-mp="3nbq9a94u379r">
                  <span className="text-3xl font-bold text-[#0F172A] font-heading" data-id="element-268" data-mp="3nbgkgoviz65n">
                    {kpi.value}
                  </span>
                  <span className={`text-sm font-medium mb-1 ${kpi.noteColor}`} data-id="element-269" data-mp="2un1gqyhuga9m">
                    {kpi.note}
                  </span>
                </div>
              </div>;
        })}
        </div>
      </section>

      {/* SECTION — ATNA Recommendations & Reliability */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-270" data-mp="34f78c746opoa">
        <section className="lg:col-span-2" data-id="element-271" data-mp="26wox4qd8kp37">
          <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-6 h-full relative overflow-hidden" data-id="element-272" data-mp="26vvzqg063bxq">
            <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-273" data-mp="hgblar4lqg0a">
              <SparklesIcon className="w-32 h-32 text-[#4F46E5]" data-id="element-274" data-mp="heicp6afhlpn" />
            </div>
            <div className="relative z-10" data-id="element-275" data-mp="dgkp27wb37od">
              <div className="flex items-center gap-2 mb-4" data-id="element-276" data-mp="r64kesnk52nn">
                <SparklesIcon className="w-6 h-6 text-[#4F46E5]" data-id="element-277" data-mp="r7pgimpistnm" />
                <h2 className="text-xl font-bold text-[#0F172A] font-heading" data-id="element-278" data-mp="memuczn2omhg">
                  Recommandations ATNA
                </h2>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-lg p-5 border border-indigo-100/50 mb-5" data-id="element-279" data-mp="w5hik9jvpw5j">
                <p className="text-slate-700 font-medium mb-1" data-id="element-280" data-mp="1a50e82vi7f0y">
                  64 questions pourraient devenir autonomes.
                </p>
                <p className="text-slate-600 text-sm mb-4" data-id="element-281" data-mp="157gx8v7f8o5b">
                  Le service Permis présente la plus faible confiance moyenne
                  (82%) et le plus de validations en attente.
                </p>
                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2" data-id="element-282" data-mp="36zdd2h0mgk5w">
                  Action Recommandée
                </h4>
                <ul className="space-y-2 mb-4" data-id="element-283" data-mp="1reuk9e04i86a">
                  <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-284" data-mp="1rgp3mnvqxs89">
                    <CheckCircle2Icon className="w-4 h-4 text-emerald-500" data-id="element-285" data-mp="1dmobwe37p5he" />{' '}
                    Valider les réponses sous le seuil de 95%
                  </li>
                  <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-286" data-mp="13oqpzx8trkry">
                    <CheckCircle2Icon className="w-4 h-4 text-emerald-500" data-id="element-287" data-mp="18ntjckfg02k3" />{' '}
                    Documenter les 7 questions sans réponse
                  </li>
                  <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-288" data-mp="uqetxfp6vus4">
                    <CheckCircle2Icon className="w-4 h-4 text-emerald-500" data-id="element-289" data-mp="yqfezj6sn485" />{' '}
                    Résoudre l'incohérence « collecte organique »
                  </li>
                </ul>
                <div className="flex items-center gap-4 p-3 bg-emerald-50 rounded-lg border border-emerald-100" data-id="element-290" data-mp="2t2n4gh0ciswj">
                  <div className="flex-1" data-id="element-291" data-mp="5wsid8c2z5l6">
                    <div className="text-xs font-bold text-emerald-800 uppercase tracking-wider mb-1" data-id="element-292" data-mp="wo13g3cm6tw">
                      Impact Prévu
                    </div>
                    <div className="flex gap-4 text-sm font-medium text-emerald-700" data-id="element-293" data-mp="3t2b2rq5w2z67">
                      <span data-id="element-294" data-mp="3o2ygb6ixju45">↑ 12% de réponses autonomes</span>
                      <span data-id="element-295" data-mp="om8kg03ez63p">↓ 28% de validations humaines</span>
                    </div>
                  </div>
                </div>
              </div>
              <button className="flex items-center gap-2 bg-[#4F46E5] hover:bg-[#4338CA] text-white px-5 py-2.5 rounded-lg font-medium transition-colors shadow-sm shadow-indigo-200" data-id="element-296" data-mp="kmhtnwdw0pz6">
                Réviser les réponses prioritaires{' '}
                <ArrowRightIcon className="w-4 h-4" data-id="element-297" data-mp="18ahiurvjw8bn" />
              </button>
            </div>
          </div>
        </section>

        <section className="lg:col-span-1" data-id="element-298" data-mp="13ihgkss0d3bw">
          <div className="bg-gradient-to-br from-[#0F172A] to-[#1E293B] rounded-xl p-6 h-full text-white shadow-lg relative overflow-hidden" data-id="element-299" data-mp="1audxzfauvxo3">
            <div className="absolute -right-10 -bottom-10 w-40 h-40 bg-[#4F46E5] rounded-full blur-3xl opacity-30" data-id="element-300" data-mp="1fujrz24llw9c"></div>
            <h2 className="text-xl font-bold font-heading mb-6" data-id="element-301" data-mp="1kr0k07ex4urp">
              Fiabilité de l'IA
            </h2>
            <div className="space-y-5 relative z-10" data-id="element-302" data-mp="1os2i2kx3n0s3">
              <div data-id="element-303" data-mp="1tu1knsl0ltnz">
                <div className="text-3xl font-bold text-[#4F46E5] mb-1" data-id="element-304" data-mp="1tsqke2qs341m">
                  96.4%
                </div>
                <div className="text-sm text-slate-300" data-id="element-305" data-mp="1yq9xgzbqparz">
                  Confiance moyenne des réponses
                </div>
              </div>
              <div className="h-px bg-slate-700/50" data-id="element-306" data-mp="28io4o7ll79lj"></div>
              <ul className="space-y-3" data-id="element-307" data-mp="28k8trhp4u0c0">
                <li className="flex items-center justify-between" data-id="element-308" data-mp="2ckj1ayskoysz">
                  <span className="text-sm text-slate-300" data-id="element-309" data-mp="2chwx994w51fi">
                    Réponses vérifiées
                  </span>
                  <span className="font-bold" data-id="element-310" data-mp="32t9mkixf8tr5">98.7%</span>
                </li>
                <li className="flex items-center justify-between" data-id="element-311" data-mp="2xuq1slukdo0d">
                  <span className="text-sm text-slate-300" data-id="element-312" data-mp="2xug9uspyl6s1">
                    Réponses autonomes
                  </span>
                  <span className="font-bold" data-id="element-313" data-mp="3cpmfvfp215ld">81%</span>
                </li>
                <li className="flex items-center justify-between" data-id="element-314" data-mp="37tnk371eclax">
                  <span className="text-sm text-slate-300" data-id="element-315" data-mp="2k4ctgidrg7ai">
                    Validations humaines
                  </span>
                  <span className="font-bold" data-id="element-316" data-mp="2f61j86jjzurr">320</span>
                </li>
                <li className="flex items-center justify-between" data-id="element-317" data-mp="2tu61j9ep24a0">
                  <span className="text-sm text-slate-300" data-id="element-318" data-mp="2p2o24psbkbr5">
                    Incohérences détectées
                  </span>
                  <span className="font-bold" data-id="element-319" data-mp="21bs43ax9skbg">3</span>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      {/* SECTION — Performance par service */}
      <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-320" data-mp="bun24gdt55pn">
        <h2 className="text-lg font-bold text-[#0F172A] font-heading mb-6" data-id="element-321" data-mp="gmoavsbroeax">
          Performance par service
        </h2>
        <div className="overflow-x-auto" data-id="element-322" data-mp="1ytlakt22q22">
          <table className="w-full text-sm text-left" data-id="element-323" data-mp="6wl9p4uhru1i">
            <thead className="text-xs text-slate-500 uppercase bg-slate-50" data-id="element-324" data-mp="6x4senryumgl">
              <tr data-id="element-325" data-mp="ulwaunfr7qg6">
                <th className="px-4 py-3 rounded-l-lg" data-id="element-326" data-mp="umpcj9zuvprg">Service</th>
                <th className="px-4 py-3" data-id="element-327" data-mp="zlsg0q06tnxb">Questions traitées</th>
                <th className="px-4 py-3" data-id="element-328" data-mp="ziwj9502t5ag">Confiance moyenne</th>
                <th className="px-4 py-3 rounded-r-lg" data-id="element-329" data-mp="lkpx2m4hotqm">Réponses autonomes</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-330" data-mp="pl9snl9ezpan">
              {[{
              name: 'Travaux publics',
              count: '4,180',
              confidence: 97,
              autonomy: 88,
              best: true
            }, {
              name: 'Loisirs',
              count: '1,920',
              confidence: 96,
              autonomy: 85,
              best: false
            }, {
              name: 'Urbanisme',
              count: '3,210',
              confidence: 91,
              autonomy: 74,
              best: false
            }, {
              name: 'Environnement',
              count: '2,540',
              confidence: 89,
              autonomy: 68,
              best: false
            }, {
              name: 'Permis',
              count: '990',
              confidence: 82,
              autonomy: 51,
              best: false
            }].map((row, i) => <tr key={i} className={row.best ? 'bg-indigo-50/30' : ''} data-id="element-331" data-mp="2qwd7vx3ej7r4" data-mpi={i}>
                  <td className="px-4 py-3 font-medium text-slate-900 flex items-center gap-2" data-id="element-332" data-mp="2uwx5f1rw0dds">
                    {row.name}
                    {row.best && <span className="px-2 py-0.5 text-[10px] bg-[#4F46E5] text-white rounded-full font-bold" data-id="element-333" data-mp="p1cpficdwo1z">
                        PLUS FIABLE
                      </span>}
                  </td>
                  <td className="px-4 py-3 text-slate-600" data-id="element-334" data-mp="2dkgtrwjxtesv">{row.count}</td>
                  <td className="px-4 py-3" data-id="element-335" data-mp="29mstedzh6ttl">
                    <div className="flex items-center gap-2" data-id="element-336" data-mp="2nccvdhl8fn1u">
                      <span className="w-8" data-id="element-337" data-mp="2nepkqftbkzox">{row.confidence}%</span>
                      <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-338" data-mp="2ikv1fdhmmmqd">
                        <div className="h-full bg-[#4F46E5]" style={{
                      width: `${row.confidence}%`
                    }} data-id="element-339" data-mp="2x9ra9cric3s1"></div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3" data-id="element-340" data-mp="36ayx8yokpi6t">
                    <div className="flex items-center gap-2" data-id="element-341" data-mp="31cnlgiepwxly">
                      <span className="w-8" data-id="element-342" data-mp="31d71ftkt5bxc">{row.autonomy}%</span>
                      <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-343" data-mp="1byiqlwrv821f">
                        <div className="h-full bg-emerald-500" style={{
                      width: `${row.autonomy}%`
                    }} data-id="element-344" data-mp="16z68fpbxvj56"></div>
                      </div>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </section>

      {/* SECTION — Service reliability & Answer funnel */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-345" data-mp="3l0f6ojih5yjr">
        <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 flex flex-col" data-id="element-346" data-mp="3l1q9ag06p09a">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading mb-4" data-id="element-347" data-mp="3pz8a1j41s967">
            Fiabilité par service
          </h2>
          <div className="flex gap-2 mb-6 overflow-x-auto pb-2" data-id="element-348" data-mp="3jx9f27d88m4">
            {services.map(service => <button key={service.name} onClick={() => setSelectedService(service.name)} className={`px-3 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors border ${selectedService === service.name ? 'bg-[#0F172A] text-white border-[#0F172A]' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-349" data-mp="3m9qze97ogyn">
                <div className="flex items-center gap-2" data-id="element-350" data-mp="221zedhpmcjcd">
                  <div className={`w-2 h-2 rounded-full ${service.status === 'green' ? 'bg-emerald-500' : service.status === 'yellow' ? 'bg-amber-400' : 'bg-red-500'}`} data-id="element-351" data-mp="21zcv4ktd8feb"></div>
                  {service.name}
                </div>
              </button>)}
          </div>
          <div className="flex-1 bg-slate-50 rounded-xl border border-slate-100 p-5 flex flex-col justify-center relative overflow-hidden" data-id="element-352" data-mp="1o39drs3lc1j9">
            <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-353" data-mp="2gqlrrdvor10y">
              <div className="w-full h-full" style={{
              backgroundImage: 'radial-gradient(#4F46E5 1px, transparent 1px)',
              backgroundSize: '20px 20px'
            }} data-id="element-354" data-mp="2greywfyk3sjm"></div>
            </div>
            <div className="relative z-10" data-id="element-355" data-mp="26yzivo6tle1d">
              <div className="flex items-center gap-3 mb-4" data-id="element-356" data-mp="34h9e346clt71">
                <MapPinIcon className="w-6 h-6 text-[#4F46E5]" data-id="element-357" data-mp="2zphkslvt59d7" />
                <h3 className="text-xl font-bold text-[#0F172A]" data-id="element-358" data-mp="2znwnioi3zcbn">
                  {activeServiceData.name}
                </h3>
                <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${activeServiceData.status === 'green' ? 'bg-emerald-100 text-emerald-700' : activeServiceData.status === 'yellow' ? 'bg-amber-100 text-amber-700' : 'bg-red-100 text-red-700'}`} data-id="element-359" data-mp="2o91tow0p2q0h">
                  {activeServiceData.status === 'green' ? 'Haute Fiabilité' : activeServiceData.status === 'yellow' ? 'Fiabilité Moyenne' : 'Faible Fiabilité'}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-360" data-mp="36z1e35llbgxk">
                <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm" data-id="element-361" data-mp="2t8eihmb4m75p">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-362" data-mp="2y6zfzdyzucqg">
                    Questions traitées
                  </div>
                  <div className="font-bold text-lg text-[#0F172A]" data-id="element-363" data-mp="3lvsglnqk98re">
                    {activeServiceData.questions}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm" data-id="element-364" data-mp="3wy5q08ub7mg">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-365" data-mp="3uljhaw1ub3l">
                    Confiance moyenne
                  </div>
                  <div className="font-bold text-lg text-[#0F172A]" data-id="element-366" data-mp="dnaopo10asqh">
                    {activeServiceData.confidence}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm" data-id="element-367" data-mp="8q0s9of79gt5">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-368" data-mp="3h5kj6gseen51">
                    Réponses autonomes
                  </div>
                  <div className="font-bold text-lg text-[#0F172A]" data-id="element-369" data-mp="3r1e3wng9tmxw">
                    {activeServiceData.autonomy}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm" data-id="element-370" data-mp="3m19n0wbgaq75">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-371" data-mp="169lpayom4tna">
                    Validations en attente
                  </div>
                  <div className="font-bold text-lg text-[#0F172A]" data-id="element-372" data-mp="19d1k1sljl9vc">
                    {activeServiceData.pending}
                  </div>
                </div>
                <div className="col-span-2 bg-indigo-50 p-3 rounded-lg border border-indigo-100 shadow-sm flex justify-between items-center" data-id="element-373" data-mp="1dd1z9fggtp3g">
                  <div className="text-sm font-medium text-indigo-900" data-id="element-374" data-mp="1nckh9qctf0sv">
                    Validations en attente
                  </div>
                  <div className="font-bold text-xl text-[#4F46E5]" data-id="element-375" data-mp="pqdcoggih8gi">
                    {activeServiceData.pending}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Answer funnel */}
        <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-376" data-mp="14doomjgluuh5">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading mb-6" data-id="element-377" data-mp="6ykkupd6htad">
            Parcours de réponse
          </h2>
          <div className="space-y-2" data-id="element-378" data-mp="bx49wyn2jl6y">
            {[{
            label: 'Questions reçues',
            value: '14,980',
            percent: 100,
            color: 'bg-slate-800'
          }, {
            label: 'Questions comprises',
            value: '14,230',
            percent: 95,
            color: 'bg-[#4F46E5]'
          }, {
            label: 'Réponse trouvée',
            value: '13,510',
            percent: 90,
            color: 'bg-indigo-400'
          }, {
            label: 'Confiance ≥ 95%',
            value: '12,140',
            percent: 81,
            color: 'bg-indigo-300'
          }, {
            label: 'Réponse autonome',
            value: '11,520',
            percent: 77,
            color: 'bg-emerald-400'
          }, {
            label: 'Réponse vérifiée',
            value: '11,370',
            percent: 76,
            color: 'bg-emerald-500'
          }].map((step, i) => <div key={i} className="relative" data-id="element-379" data-mp="2xvmbx5m7s4fl" data-mpi={i}>
                <div className="flex items-center justify-between mb-1 px-1" data-id="element-380" data-mp="2xyiamw5vyx53">
                  <span className="text-sm font-medium text-slate-700" data-id="element-381" data-mp="2tvvjkxh1hg8y">
                    {step.label}
                  </span>
                  <span className="text-sm font-bold text-slate-900" data-id="element-382" data-mp="ql74o3yy5ua4">
                    {step.value}
                  </span>
                </div>
                <div className="w-full h-8 bg-slate-100 rounded-lg overflow-hidden flex items-center" data-id="element-383" data-mp="bnoi989qrt5u">
                  <div className={`h-full ${step.color} flex items-center justify-end px-3 transition-all duration-1000`} style={{
                width: `${step.percent}%`
              }} data-id="element-384" data-mp="glq1pub2xuhu">
                    <span className="text-xs font-bold text-white drop-shadow-md" data-id="element-385" data-mp="7neabq2e2soc">
                      {step.percent}%
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </section>
      </div>

      {/* SECTION — Answer statuses & Top insights */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-386" data-mp="3g2y02f3upsyn">
        <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-387" data-mp="3k49j21s7zfxv">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading mb-6" data-id="element-388" data-mp="31f7frh2s7exc">
            Répartition des réponses
          </h2>
          <div className="space-y-4" data-id="element-389" data-mp="2whxtubelple9">
            {[{
            status: 'Autonomes (vérifiées)',
            count: '11,370',
            share: '81%',
            color: 'bg-emerald-500'
          }, {
            status: 'À réviser',
            count: '1,540',
            share: '11%',
            color: 'bg-amber-500'
          }, {
            status: 'Escaladées à un expert',
            count: '840',
            share: '6%',
            color: 'bg-indigo-400'
          }, {
            status: 'Bloquées (sous le seuil)',
            count: '230',
            share: '2%',
            color: 'bg-red-500'
          }].map((item, i) => <div key={i} className="flex items-center justify-between p-3 hover:bg-slate-50 rounded-lg transition-colors border border-transparent hover:border-slate-100" data-id="element-390" data-mp="3p7nzrx62xgza" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-391" data-mp="225c96gz57a1">
                  <div className={`w-2.5 h-2.5 rounded-full ${item.color}`} data-id="element-392" data-mp="eispj0bvn0rm"></div>
                  <div className="font-medium text-slate-900" data-id="element-393" data-mp="9khiexcyv4d3">
                    {item.status}
                  </div>
                </div>
                <div className="flex gap-6 text-right items-center" data-id="element-394" data-mp="og6yyfzdupaf">
                  <div className="font-medium text-[#0F172A]" data-id="element-395" data-mp="jhvpi6d02gsq">{item.count}</div>
                  <div className="bg-indigo-50 px-2 py-1 rounded text-center min-w-[3rem]" data-id="element-396" data-mp="3ry8cn5rj6u8i">
                    <div className="font-bold text-[#4F46E5]" data-id="element-397" data-mp="3mz5gybxfy0d7">{item.share}</div>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 flex flex-col" data-id="element-398" data-mp="5jyrd5iwe2by">
          <div className="flex items-center gap-2 mb-6" data-id="element-399" data-mp="pufc7urz440">
            <SparklesIcon className="w-5 h-5 text-[#4F46E5]" data-id="element-400" data-mp="396p8gvlrta4w" />
            <h2 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-401" data-mp="348npeaochatf">
              Insights ATNA : Priorités d'amélioration
            </h2>
          </div>
          <div className="bg-slate-50 rounded-xl p-1 flex-1" data-id="element-402" data-mp="1jp0nsi4u3340">
            <ul className="space-y-1" data-id="element-403" data-mp="1ohlh7ijtve70">
              {[{
              label: 'Réponses à réviser',
              count: 14
            }, {
              label: 'Questions sans réponse officielle',
              count: 7
            }, {
              label: 'Incohérences entre sources',
              count: 3
            }, {
              label: 'Validations humaines en attente',
              count: 5
            }, {
              label: 'Sujets à fort volume non documentés',
              count: 9
            }].map((item, i) => <li key={i} className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm" data-id="element-404" data-mp="1tfvebyp44ov9" data-mpi={i}>
                  <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${i < 3 ? 'bg-[#4F46E5] text-white' : 'bg-slate-100 text-slate-500'}`} data-id="element-405" data-mp="1xgf9iwq4lier">
                    {i + 1}
                  </span>
                  <span className="text-sm font-medium text-slate-700" data-id="element-406" data-mp="m0ibmj0b7o5e">
                    {item.label}
                  </span>
                  <span className="ml-auto text-sm font-bold text-[#0F172A]" data-id="element-407" data-mp="2jpvvip1yk5wl">
                    {item.count}
                  </span>
                  {i < 3 && <TrendingUpIcon className="w-4 h-4 text-amber-500" data-id="element-408" data-mp="2exw099wu216c" />}
                </li>)}
            </ul>
          </div>
        </section>
      </div>
    </div>;
}